'use client'
import React, { Fragment } from 'react'

export function IDCell({ id }: { id: number | string }) {
  return <Fragment>{id}</Fragment>
}
